

















































































































































import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import { Practice as IPractice } from "@/api/models/practice";
import EditorWithFile from "@/components/EditorWithFile.vue";
import FileManager from "@/components/files/FileManager.vue";
import { FileItem as IFileItem } from "@/api/models/file-item";
import { PracticePassAnswer as IPracticePassAnswer } from "@/api/models/practice-pass-answer";
import { Course as ICourse } from "@/api/models/course";
import { uniqBy } from "lodash";
import api from "@/getinfo-api";
import { AxiosError } from "axios";
import { ErrorResponse as IErrorResponse } from "@/api/models/error-response";
import { ValidationErrorResponse as IValidationErrorResponse } from "@/api/models/validation-error-response";
import { getCurrentUserId, isRoot } from "@/plugins/roles";

@Component({
  components: { EditorWithFile, FileManager }
})
export default class Practice extends Vue {
  @Prop() practice?: IPractice;
  @Prop() course?: ICourse;
  body!: string;
  usersFiles!: Array<IFileItem>;
  showFileManager: boolean = false;
  data() {
    return {
      body: undefined,
      usersFiles: []
    };
  }

  savePracticePass() {
    let selectedFilesId: Array<string> = [];
    if (this.usersFiles.length) {
      this.usersFiles.forEach(element => {
        selectedFilesId.push(element.id);
      });
    }

    let params: IPracticePassAnswer = {
      body: this.body,
      files: this.usersFiles.length ? selectedFilesId : undefined
    };
    api.PracticeApi.pass(this.$route.params.courseId, params)
      .then(() => {
        this.$router.push({ name: "myPractices" });
      })
      .catch((err: AxiosError<IValidationErrorResponse | IErrorResponse>) => {
        this.$store.dispatch("errorException", {
          vm: this,
          error: err.response
        });
      });
  }

  get userCanEditCourse() {
    return this.root || this.companyOwner || this.entityOwner;
  }

  get root() {
    return isRoot();
  }

  get userId() {
    return getCurrentUserId();
  }

  get companyOwner() {
    return this.userId === this.course?.company.owner.id;
  }

  get entityOwner() {
    return this.userId === this.course?.owner.id;
  }

  deleteFile(file: IFileItem) {
    this.usersFiles = this.usersFiles.filter(value => {
      return value !== file;
    });
  }

  get screenWidth() {
    return window.innerWidth;
  }

  addFileToPractice(item: IFileItem) {
    if (item) {
      this.usersFiles.push(item);
      this.usersFiles = uniqBy(this.usersFiles, item => {
        return item.id;
      });
    }
  }

  @Watch("usersFiles")
  checkUserFiles() {
    document.querySelector(".table-files-mobile")?.scrollIntoView({
      block: "center",
      behavior: "smooth",
      inline: "nearest"
    });
  }
}
